import React from "react";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import "features/application/details/view.scss";
import { capitalize } from "../../../utils/capitalize";

const DetailsView = ({
  userData,
  invalidFields,
  references,
  backToPreviousStep,
  sendApiRequest,
}) => (
  <form
    className="form__content details__content"
    noValidate
    onSubmit={sendApiRequest}
  >
    <h1 className="application__headline form__elongation">Details</h1>
    <Field
      label="First name"
      name="first_name"
      type="text"
      maxLength={191}
      value={userData && userData.first_name && userData.first_name}
      shouldValidate={true}
      rule="required"
      error="It doesn't look like a valid field."
    />
    <Field
      label="Last name"
      name="last_name"
      type="text"
      maxLength={191}
      value={userData && userData.last_name && userData.last_name}
      shouldValidate={true}
      rule="required"
      error="It doesn't look like a valid field."
    />
    <Field
      label="Gender"
      name="gender"
      type="gender"
      maxLength={191}
      value={userData && userData.gender && capitalize(userData.gender)}
      shouldValidate={true}
      rule="gender"
      error="This field is required."
    />
    <div className="details__birthdate">
      <Field
        label="Date of birth"
        placeholder="MM"
        name="month"
        type="text"
        maxLength={2}
        value={userData && userData.birthday && userData.birthday.split("-")[1]}
        shouldValidate={true}
        rule="month"
        error="It doesn't look like a valid field."
        reference={references.month}
      />
      <Field
        placeholder="DD"
        name="day"
        type="text"
        maxLength={2}
        value={userData && userData.birthday && userData.birthday.split("-")[2]}
        shouldValidate={true}
        rule="day"
        error={
          !invalidFields.includes("month")
            ? "It doesn't look like a valid field."
            : ""
        }
        reference={references.day}
      />
      <Field
        placeholder="YEAR"
        name="year"
        type="text"
        maxLength={4}
        value={userData && userData.birthday && userData.birthday.split("-")[0]}
        shouldValidate={true}
        rule="year"
        error={
          !invalidFields.includes("day") && !invalidFields.includes("month")
            ? "It doesn't look like a valid field."
            : ""
        }
        reference={references.year}
      />
    </div>
    <Field
      label="Home Zip code"
      name="home_address_zip"
      type="text"
      maxLength={10}
      value={userData && userData.home_address_zip && userData.home_address_zip}
      shouldValidate={true}
      rule="zipCode"
      error="It doesn't look like a valid field."
    />
    <Field
      label="Work Zip code"
      name="work_address_zip"
      type="text"
      maxLength={10}
      value={userData && userData.work_address_zip && userData.work_address_zip}
      shouldValidate={false}
      rule="zipCode"
      error="It doesn't look like a valid field."
    />
    <div className="application__buttons form__elongation">
      <button
        className="application__button"
        type="button"
        onClick={backToPreviousStep}
      >
        Back
      </button>
      <button className="application__button" type="submit">
        Next
      </button>
    </div>
  </form>
);

DetailsView.propTypes = {
  userData: PropTypes.object,
  invalidFields: PropTypes.array,
  references: PropTypes.object,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
};

export default DetailsView;
